import React, { Component } from "react";
import PropTypes from "prop-types";

class CampaignsEditBtn extends Component {
  static propTypes = {
    campaign: PropTypes.object.isRequired,
    handleEdit: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { disabled: false };
  }

  onEditClick() {
    this.props.handleEdit(this.props.campaign.id);
    this.setState({ disabled: true });
  }

  render() {
    return (
      <button
        className="btn btn-primary pull-right campaign_edit"
        onClick={this.onEditClick.bind(this)}
        disabled={this.state.disabled}
      >
        Edit
      </button>
    );
  }
}

export default CampaignsEditBtn;
